import React from "react"
import PropTypes from "prop-types"
import Button from "@irati/ui/src/Button"
import {FormattedMessage} from "@irati/utils/lang"

const GetStarted = ({onClick}) => (
  <Button primary onClick={onClick}>
    <FormattedMessage id="recognition.onboarding.buttons.getStarted" />
  </Button>
)

GetStarted.propTypes = {
  onClick: PropTypes.func.isRequired
}

export default GetStarted
